
export enum SubscriptionFrequency {
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
    OFF = 'OFF'
}

export enum SubscriptionType {
    REPORT_SUBSCRIPTION = 'REPORT_SUBSCRIPTION',
}

export const SubscriptionFrequencyLabel: Record<SubscriptionFrequency, string> = {
    [SubscriptionFrequency.MONTHLY]: 'Monthly',
    [SubscriptionFrequency.WEEKLY]: 'Weekly',
    [SubscriptionFrequency.OFF]: 'Off'
};

export interface SubscriptionDto {
    subscriptionType: SubscriptionType;
    frequency: SubscriptionFrequency;
}